import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { fontFamilies, colors } from '../../constants/theme';
import startVideoConsultationBackground from '../../assets/images/start-video-consultation-bg.webp';
import { figmaLetterSpacing } from '../../ui/utils';

export const Wrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'bgImg',
})(({ bgImg = startVideoConsultationBackground, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: 1400,
  maxHeight: 789,
  width: '100%',
  height: '100vh',
  background: `linear-gradient(180deg, rgba(82, 31, 12, 0.4) 0%, rgba(82, 31, 12, 0.4) 100%), url(${bgImg})`,
  boxShadow: `
    -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15),
     4px  4px 15px   0px rgba(205, 214, 223, 0.25)
  `,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: 20,
  [theme.breakpoints.down('md')]: {
    maxHeight: 'none',
    height: 'auto',
    minHeight: '500px',
    borderRadius: 16,
    padding: '60px 40px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '400px',
    borderRadius: 12,
    padding: '40px 24px',
  },
  '& .MuiButtonBase-root': {
    alignSelf: 'center',
    color: colors.whiteText,
    borderColor: colors.whiteText,
    '&:hover': {
      backgroundColor: 'rgba(82, 31, 12, 0.4)',
    },
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: 50,
  lineHeight: '58px',
  letterSpacing: figmaLetterSpacing(50, -1),
  fontWeight: 500,
  color: '#FFFFFF',
  textTransform: 'capitalize',
  textAlign: 'center',
  textWrap: 'balance',
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('md')]: {
    fontSize: 36,
    lineHeight: '42px',
    letterSpacing: figmaLetterSpacing(36, -1),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 22,
    lineHeight: '26px',
    letterSpacing: figmaLetterSpacing(28, -1),
  },
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontSize: 32,
  fontWeight: 500,
  lineHeight: '100%',
  letterSpacing: figmaLetterSpacing(32, 2),
  textAlign: 'center',
  color: colors.whiteText,
  margin: '0 auto',
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
    letterSpacing: figmaLetterSpacing(24, 2),
    maxWidth: '100%',
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 20,
    letterSpacing: figmaLetterSpacing(20, 2),
    padding: '0 16px',
  },
}));
